import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setMessage } from "../../redux";
import "./style.css"

function Home() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchBar, setSearchBar] = useState('');
    const [users, setUsers] = useState([]);
    const [more, setMore] = useState(null);

    useEffect(() => {
        const fetchUsers = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/users/get`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
            });
            const res = await req.json();
            dispatch(setMessage());

            if (req.status !== 200) {
                localStorage.removeItem('email');
                localStorage.removeItem('password');
                sessionStorage.removeItem('email');
                sessionStorage.removeItem('password');
                navigate('/login');
                return;
            }
            setUsers(res);
        }
        dispatch(setMessage('Chargement en cour, merci de patienter'));
        fetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredUsers = users.filter(user =>
        user.lastName.toLowerCase().includes(searchBar.toLowerCase()) ||
        user.firstName.toLowerCase().includes(searchBar.toLowerCase()) ||
        user.profession.toLowerCase().includes(searchBar.toLowerCase())
    );

    return (
        <div className="page_home">
            <div className="options">
                <div className="search_bar">
                    <input
                        type="text"
                        placeholder="Nom / Prénom / Profession / ..."
                        value={searchBar}
                        onChange={(e) => setSearchBar(e.target.value)}
                    />
                    <i className="fas fa-magnifying-glass"></i>
                </div>
            </div>

            {filteredUsers.length !== 0 ? (
                <ul className="list_users">
                    {filteredUsers.map((user, idx) => (
                        <li className="onglet" onClick={() => setMore(user)} key={idx}>
                            <p><span>Profession :</span> {user.profession}</p>
                            <p><span>Nom et Prénom :</span> {user.lastName} {user.firstName}</p>
                            <p><span>Lieu d'exercice :</span> {user.mainLocation}</p>
                            <p><span>Adresse professionnelle :</span> {user.secondaryLocations}</p>
                            <p><span>Téléphone direct :</span> {user.proPhone}</p>
                            <p><span>Email direct :</span> {user.proEmail}</p>
                            <p><span>Note :</span> {user.importantInfo || 'Aucune note'}</p>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="not_found">Aucun résultat</p>
            )}

            {more &&
                <div className="mdl_show_more">
                    <button className="close" onClick={() => setMore(null)}>
                        <i className="fas fa-xmark"></i>
                    </button>

                    <div className="content">
                        <h2>Fiche Personnelle Annuaire PSOA</h2>

                        <div className="lists">
                            <ul>
                                <li><h3>Identité du professionnel</h3></li>
                                <li><span>Nom et Prénom :</span> {more.lastName} {more.firstName}</li>
                                <li><span>Profession :</span> {more.profession}</li>
                                <li><span>Lieu d’exercice :</span> {more.mainLocation}</li>
                                <li><span>Adresse professionnelle :</span> {more.secondaryLocations}</li>
                                <li><span>Téléphone direct :</span> {more.proPhone}</li>
                                <li><span>Téléphone secrétariat :</span> {more.secretaryPhone}</li>
                                <li><span>Email professionnel :</span> {more.proEmail}</li>
                                <li><span>Email professionnel sécurisé :</span> {more.secureProEmail}</li>
                            </ul>
                            <ul>
                                <li><h3>Outils de communication</h3></li>

                                {[
                                    { label: "Au sujet d’un patient :", items: more.patientComTool, other: more.otherPatientComTool },
                                    { label: "Les échanges administratifs :", items: more.adminComTool, other: more.otherAdminComTool },
                                    { label: "Avis ou un conseil interprofessionnel :", items: more.interproTool, other: more.otherInterproTool },
                                    { label: "Pour organiser une réunion :", items: more.meetingTool, other: more.otherMeetingTool }
                                ].map((category, catIdx) => (
                                    <li key={catIdx}>
                                        <span>{category.label}</span>
                                        {category.items.length > 0 && category.items.map((e, idx) =>
                                            e !== 'AUTRE' && <p key={idx}>{e}{idx !== category.items.length - 1 && ','}</p>
                                        )}
                                        {category.other && <p>{category.other}</p>}
                                    </li>
                                ))}
                            </ul>
                            <ul>
                                <li><h3>Modalités de contact</h3></li>

                                {[
                                    { label: "En cas d’urgence (< 2 heures) :", items: more.urgentContact, other: more.otherUrgentContact },
                                    { label: "Pour une réponse sous 24 heures :", items: more.dailyContact, other: more.otherDailyContact },
                                    { label: "Pour un délai d’environ une semaine :", items: more.weeklyContact, other: more.otherWeeklyContact }
                                ].map((category, catIdx) => (
                                    <li key={catIdx}>
                                        <span>{category.label}</span>
                                        {category.items.length > 0 && category.items.map((e, idx) =>
                                            e !== 'AUTRE' && <p key={idx}>{e}{idx !== category.items.length - 1 && ','}</p>
                                        )}
                                        {category.other && <p>{category.other}</p>}
                                    </li>
                                ))}
                            </ul>
                            <ul>
                                <li><h3>Information important à mentionner</h3></li>

                                <li>
                                    <span>Publics de prédilection :</span>
                                    {more.targetAudiences.length > 0 && more.targetAudiences.map((e, idx) => e !== 'AUTRE' &&
                                        <p key={idx}>{e}{idx !== more.targetAudiences.length - 1 && ','}</p>
                                    )}
                                    {more.otherTargetAudiences && <p>{more.otherTargetAudiences}</p>}
                                </li>
                                <li><span>Notes importantes :</span> {more.importantInfo}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Home;